import { API } from '@/plugins/api'
import { hamiVuex } from '@/store/base'
import Vue from 'vue'
import { projectStore } from './project'
import _ from 'lodash'
import { BalanceTaskStatus } from '@/plugins/balanceTask'

export const balanceTaskStore = hamiVuex.store({
  $name: '',
  $state: {
    balanceTaskMap: {},
  },
  LOAD(item_s) {
    let map = {}
    _.forEach(item_s, item => {
      map[item.id] = item
    })
    this.$patch(state => {
      state.balanceTaskMap = map
    })
  },
  UPSET(item) {
    this.$patch(state => {
      Vue.set(state.balanceTaskMap, item.id, item)
    })
  },
  get(id) {
    return this.balanceTaskMap[id]
  },
  get list() {
    return _.sortBy(_.values(this.balanceTaskMap), ['dt_created'])
  },
  doLoad: _.once(async function doLoad() {
    let payload = { project_id: projectStore.currentId }
    let result = await API.call('merchant/balance_task.query', payload)
    this.LOAD(result.item_s)
  }),
  async doCreate({ file, ...payload }) {
    payload.project_id = projectStore.currentId
    let result = await API.upload('merchant/balance_task.create', file, payload)
    this.UPSET(result)
    return result
  },
  async doCreateOneshot(payload) {
    payload.project_id = projectStore.currentId
    let result = await API.call('merchant/balance_task.create_oneshot', payload)
    this.UPSET(result)
    return result
  },
  async doGet(id) {
    let result = await API.call('merchant/balance_task.get', { id: id })
    this.UPSET(result)
    return result
  },
  async doDelete(id) {
    await API.call('merchant/balance_task.delete', { id: id })
    this.$patch(state => {
      Vue.delete(state.balanceTaskMap, id)
    })
  },
  async doExecute(payload) {
    try {
      // eslint-disable-next-line no-constant-condition
      while (true) {
        let result = await API.call('merchant/balance_task.execute', payload)
        this.UPSET(result)
        if (result.status !== BalanceTaskStatus.EXECUTE) {
          return result
        }
      }
    } catch (ex) {
      let result = await this.doGet(payload.id)
      this.UPSET(result)
      throw ex
    }
  },
  async doRevert(payload) {
    try {
      // eslint-disable-next-line no-constant-condition
      while (true) {
        let result = await API.call('merchant/balance_task.revert', payload)
        this.UPSET(result)
        if (result.status !== BalanceTaskStatus.REVERT) {
          return result
        }
      }
    } catch (ex) {
      let result = await this.doGet(payload.id)
      this.UPSET(result)
      throw ex
    }
  },
})
